import type { UsageStepTotals } from "../types";
import { formatCost, formatCount, stepLabel } from "../utils/format";
import { TABLE, TABLE_WRAPPER, TBODY, TD, TD_NUMBER, TH, TH_NUMBER, THEAD } from "./tableClasses";

export const StepTable = ({ steps }: { steps: UsageStepTotals[] }) => {
  if (steps.length === 0) {
    return <p className="text-sm text-zinc-500">No model calls in this period.</p>;
  }
  return (
    <div className={TABLE_WRAPPER}>
      <table className={TABLE}>
        <thead className={THEAD}>
          <tr>
            <th className={TH}>Step</th>
            <th className={TH_NUMBER}>Runs</th>
            <th className={TH_NUMBER}>Calls</th>
            <th className={TH_NUMBER}>Cost</th>
            <th className={TH_NUMBER}>Input tokens</th>
            <th className={TH_NUMBER}>Output tokens</th>
            <th className={TH_NUMBER}>Entries without a price</th>
          </tr>
        </thead>
        <tbody className={TBODY}>
          {steps.map((step) => (
            <tr key={step.step}>
              <td className={`${TD} font-medium text-zinc-900`}>{stepLabel(step.step)}</td>
              <td className={TD_NUMBER}>{step.runs.toLocaleString()}</td>
              <td className={TD_NUMBER}>{step.calls.toLocaleString()}</td>
              <td className={TD_NUMBER}>{formatCost(step.cost_usd)}</td>
              <td className={TD_NUMBER}>{formatCount(step.input_tokens)}</td>
              <td className={TD_NUMBER}>{formatCount(step.output_tokens)}</td>
              <td className={TD_NUMBER}>{step.unpriced_events.toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
